var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0m204.8 0l614.4 0q204.8 0 204.8 204.8l0 614.4q0 204.8-204.8 204.8l-614.4 0q-204.8 0-204.8-204.8l0-614.4q0-204.8 204.8-204.8Z",
    fill: "#95EFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M819.2 0H534.272A756.48 756.48 0 0 0 0 483.584V819.2a204.8 204.8 0 0 0 204.8 204.8h614.4a204.8 204.8 0 0 0 204.8-204.8V204.8a204.8 204.8 0 0 0-204.8-204.8z",
    fill: "#88EDBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M819.2 0h-3.84a755.2 755.2 0 0 0-539.392 1024H819.2a204.8 204.8 0 0 0 204.8-204.8V204.8a204.8 204.8 0 0 0-204.8-204.8z",
    fill: "#79E8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M497.152 721.152A752.384 752.384 0 0 0 560.384 1024H819.2a204.8 204.8 0 0 0 204.8-204.8V204.8a204.8 204.8 0 0 0-89.088-168.96 755.2 755.2 0 0 0-437.76 685.312z",
    fill: "#69E2B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 204.8a307.2 307.2 0 0 0-204.8 535.808V793.6a25.6 25.6 0 0 0 25.6 25.6h179.2a307.2 307.2 0 0 0 0-614.4z",
    fill: "#D7FFE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M742.4 512A307.2 307.2 0 0 0 473.6 207.36 307.2 307.2 0 0 0 307.2 740.608V793.6a25.6 25.6 0 0 0 25.6 25.6h102.4a307.2 307.2 0 0 0 307.2-307.2z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M486.4 473.6m25.6 0l0 0q25.6 0 25.6 25.6l0 25.6q0 25.6-25.6 25.6l0 0q-25.6 0-25.6-25.6l0-25.6q0-25.6 25.6-25.6Z",
    fill: "#79E8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384 473.6m25.6 0l0 0q25.6 0 25.6 25.6l0 25.6q0 25.6-25.6 25.6l0 0q-25.6 0-25.6-25.6l0-25.6q0-25.6 25.6-25.6Z",
    fill: "#79E8B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M588.8 473.6m25.6 0l0 0q25.6 0 25.6 25.6l0 25.6q0 25.6-25.6 25.6l0 0q-25.6 0-25.6-25.6l0-25.6q0-25.6 25.6-25.6Z",
    fill: "#79E8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42956c1302378d3b97aef8d9a6f1e7f1.svg";
export { ForwardRef as ReactComponent };